import N8nChat from './n8nChat/N8nChat';

export const ChatProvider = ({ children }: { children: React.ReactNode }) => {
  return <N8nChat>{children}</N8nChat>;
};
